import { useMediaQuery } from '@givebutter/react-util';

const useIsStickyMediaQuery = () => useMediaQuery(`(max-width: 768px)`);

export { useIsStickyMediaQuery };
